import React, { Component } from "react";
import {
  CommandBarButton,
  ActionButton,
  DefaultButton
} from "office-ui-fabric-react/lib/Button";
import { flatten } from "../../utils";

import { connect } from "react-redux";

import ExcelFile from "../../export/ExcelPlugin/components/ExcelFile";
import ExcelSheet from "../../export/ExcelPlugin/elements/ExcelSheet";
import ExcelColumn from "../../export/ExcelPlugin/elements/ExcelColumn";

class TransitExelExport extends Component {
  render() {
    const exelDataOrder = this.props.items
      ? this.props.items.map(item => flatten(item))
      : "";
    const exelDataShipment = [flatten(this.props.shipment)];
    return (
      <ExcelFile
        filename={
          "Loading list " +
          this.props.shipment.relationByRelationId.name +
          " " +
          this.props.shipment.carrierByCarrierId.truck
        }
        element={
          <DefaultButton
            styles={{ root: { padding: "10px" } }}
            disabled={this.props.items.length === 0}
            iconProps={{ iconName: "ExcelLogo" }}
            title="Transit loading list"
            text="Transit"
          />
        }
      >
        <ExcelSheet data={exelDataShipment} name="Carrier info">
          <ExcelColumn label="Date" value="date" />
          <ExcelColumn label="Shipper" value="relationByRelationId.name" />
          <ExcelColumn label="Truck" value="carrierByCarrierId.truck" />
          <ExcelColumn label="Trailer" value="carrierByCarrierId.trailer" />
        </ExcelSheet>
        <ExcelSheet data={exelDataOrder} name="Orders">
          <ExcelColumn label="Loading order" value="loadingOrder" />
          <ExcelColumn label="Master bill" value="awb" />
          <ExcelColumn label="Voyage" value="flight" />
          <ExcelColumn label="Packs" value="boxes" />
          <ExcelColumn label="Type" value="" />
          <ExcelColumn label="Full boxes" value="boxesControle" />
          <ExcelColumn label="Weight" value="brutto" />
          <ExcelColumn label="UW" value="" />
          <ExcelColumn label="Chargeable" value="chargableWeight" />
          <ExcelColumn label="KG" value="" />
          <ExcelColumn label="Order reference" value="packingCode" />
          <ExcelColumn label="Origin" value="countryByCountryId.name" />
          <ExcelColumn label="House bill number" value="hawb" />
          <ExcelColumn label="Pallets" value="amountPallets" />
          <ExcelColumn label="About" value="abount" />
        </ExcelSheet>
      </ExcelFile>
    );
  }
}

const mapStateToProps = state => {
  return {
    shipment: state.selected.shipment
  };
};

export default connect(mapStateToProps)(TransitExelExport);



// WEBPACK FOOTER //
// ./src/views/Reports/_TransitExelExport.js